import type { ReactElement, ReactNode } from 'react';
import { Float } from '@headlessui-float/react';
import { Menu } from '@headlessui/react';
import { classNames } from '@library/utils';
import menuIcon from '@library/assets/images/icons/menu-icon.svg';

export interface KebabMenuProps {
  children: ReactNode;
  className?: string;
  disabled?: boolean;
  menuButtonClassName?: string;
  menuButtonClosedClassName?: string;
  menuItemsClassName?: string;
  menuButtonOpenClassName?: string;
  float?: boolean;
  floatPlacement?: 'bottom-start' | 'bottom-end' | 'top-start' | 'top-end';
  floatZIndex?: number;
  title: string;
  testId?: string;
}

export const KebabMenu = ({
  children,
  className = '',
  disabled = undefined,
  menuButtonClassName = '',
  menuButtonClosedClassName = '',
  menuItemsClassName = '',
  menuButtonOpenClassName = '',
  float = false,
  floatPlacement = 'bottom-start',
  floatZIndex = 9,
  title,
  testId = 'kebab-menu'
}: KebabMenuProps) => {
  const renderMenu = (
    open: boolean,
    close: () => void,
    isFloating = false
  ): ReactElement[] => {
    const buttonClassName = classNames(
      open ? menuButtonOpenClassName : menuButtonClosedClassName,
      menuButtonClassName
    );

    return [
      <Menu.Button
        className={buttonClassName}
        disabled={disabled}
        title={title}
        type="button"
        data-testid={testId}
        key="kebab-menu-button"
        onClick={(event) => event.stopPropagation()}
      >
        <img src={menuIcon} alt="menu icon" />
      </Menu.Button>,
      <Menu.Items
        className={classNames(
          'divide-soFresh-140 shadow-lg',
          isFloating ? '' : 'absolute',
          menuItemsClassName
        )}
        onClick={close}
        key="kebab-menu-items"
      >
        {children}
      </Menu.Items>
    ];
  };
  return (
    <Menu as="div" className={className}>
      {({ open, close }) => {
        return float ? (
          <Float
            zIndex={floatZIndex}
            placement={floatPlacement}
            portal
            strategy="absolute"
          >
            {renderMenu(open, close, float)}
          </Float>
        ) : (
          <>{renderMenu(open, close, float)}</>
        );
      }}
    </Menu>
  );
};
